<template>
  <div class="FicheVehicule">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <el-card class="box-card">
      <v-container fluid grid-list-md>
        <p align="center">
          <v-alert
            v-if="messageAlert !== ''"
            :value="true"
            type="error"
            style="width:100%; font-size: 19px"
          >
            {{ messageAlert }}
          </v-alert>
        </p>

        <v-layout row>
          <v-flex md9>
            <v-layout row>
              <v-flex md3>
                <p align="center">
                  <v-chip
                    text-color="white"
                    label
                    color="primary"
                    style="width: 100%"
                  >
                    IMAGE DU VEHICULE
                  </v-chip>
                </p>
                <v-avatar :tile="true" size="180px">
                  <img
                    v-if="detailVeh.urlVeh == ''"
                    src="/static/car_avatar.png"
                    alt="avatar"
                  />
                  <img v-else :src="detailVeh.urlVeh" alt="avatar" />
                </v-avatar>
              </v-flex>

              <v-flex md9>
                <p align="center">
                  <v-chip
                    text-color="white"
                    label
                    color="primary"
                    style="width: 100%"
                  >
                    INFORMATIONS GENERALES CONCERNANT LE VEHICULE
                  </v-chip>
                </p>

                <v-layout row>
                  <v-flex md6>
                    <p><b>PARC AUTO : </b> {{ detailVeh.parc }}</p>
                    <p><b>MARQUE : </b> {{ detailVeh.marque }}</p>
                    <p><b>MODELE : </b> {{ detailVeh.modele }}</p>
                    <p><b>SERIE : </b> {{ detailVeh.serie }}</p>
                    <p><b>CATEGORIE : </b> {{ detailVeh.categorie }}</p>
                    <p>
                      <b>DISPONIBILITE : </b>
                      <v-chip
                        v-if="detailVeh.etat == 1"
                        label
                        text-color="white"
                        color="green"
                      >
                        DISPONIBLE <v-icon>directions_bus</v-icon>
                      </v-chip>
                      <v-chip
                        v-else-if="detailVeh.etat == 2"
                        label
                        text-color="white"
                        color="orange"
                      >
                        EN MISSION <v-icon>directions_bus</v-icon>
                      </v-chip>
                      <v-chip
                        v-else-if="detailVeh.etat == 3"
                        label
                        text-color="white"
                        color="red"
                      >
                        EN PANNE <v-icon>directions_bus</v-icon>
                      </v-chip>
                      <v-chip
                        v-else-if="detailVeh.etat == 4"
                        label
                        text-color="white"
                        color="red"
                      >
                        EN REPARATION <v-icon>directions_bus</v-icon>
                      </v-chip>
                      <v-chip
                        v-else-if="detailVeh.etat == 5"
                        label
                        text-color="white"
                        color="red"
                      >
                        EN LOCATION <v-icon>directions_bus</v-icon>
                      </v-chip>
                    </p>
                  </v-flex>

                  <v-flex md6>
                    <p><b>KILOMETRAGE : </b> {{ detailVeh.kilo }} KM</p>
                    <p><b>COULEUR : </b> {{ detailVeh.couleur }}</p>
                    <p><b>IMMATRICULATION : </b> {{ detailVeh.immat }}</p>
                    <p>
                      <b>N° DE LA CARTE GRISE : </b> {{ detailVeh.numCarte }}
                    </p>
                    <p><b>N° DU CHASSIS : </b> {{ detailVeh.numChass }}</p>
                    <p><b>TYPE DE CARBURANT : </b> {{ detailVeh.carburant }}</p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex md3>
            <p align="center">
              <v-chip text-color="white" label color="red" style="width: 100%">
                COÛT TOTAL DES DEPENSES
              </v-chip>
            </p>

            <v-layout row>
              <v-flex>
                <p>
                  <b>PRIX D'ACHAT DU VEHICULE : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(detailVeh.prixAchat)
                  }}
                  FCFA
                </p>
                <p>
                  <b>COUT D'UTILISATION : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(detailVeh.coutUtil)
                  }}
                  FCFA
                </p>
                <p><b>CARBURANT : </b> {{ detailVeh.montantCarburant }} FCFA</p>
                <p>
                  <b>INTERVENTION ET REPARATION : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(
                      detailVeh.montantInterv
                    )
                  }}
                  FCFA
                </p>
                <p>
                  <b>ASSURANCE : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(
                      detailVeh.montantAssur
                    )
                  }}FCFA
                </p>
                <p>
                  <b>VIDANGE : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(detailVeh.montantVid)
                  }}FCFA
                </p>
                <p>
                  <b>VISITE: </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(
                      detailVeh.montantVistech
                    )
                  }}
                  FCFA
                </p>
                <p style="font-size:22px">
                  <b>TOTAL : </b>
                  {{
                    new Intl.NumberFormat("fr-FR").format(detailVeh.totalCout)
                  }}
                  FCFA
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!--tabs menu-->
        <v-layout wrap>
          <v-flex md12>
            <!-- BOUTON DE GESTION -->
            <v-btn
              @click="
                $router.push({ name: 'Flotte', path: '/parc/auto/flotte' })
              "
              color="orange"
              dark
              ><v-icon left>keyboard_arrow_left</v-icon> Retour
            </v-btn>
            <v-btn @click="editVeh(detailVeh)" color="primary" dark
              >Modifier <v-icon right>edit</v-icon></v-btn
            >
            <v-btn @click="newVisit(detailVeh)" color="primary" dark
              >Visite <v-icon right>add</v-icon></v-btn
            >
            <v-btn @click="newAssu(detailVeh)" color="primary" dark
              >Assurance <v-icon right>add</v-icon></v-btn
            >
            <v-btn @click="newVign(detailVeh)" color="primary" dark
              >Vidange <v-icon right>add</v-icon></v-btn
            >
            <v-btn @click="imprimeInfoVeh" color="warning" dark
              >Imprimer<v-icon right>printer</v-icon></v-btn
            >
          </v-flex>

          <v-flex md12>
            <!-- <v-tabs  slot="extension" color="cyan" fixed icons centered dark slider-color="yellow" @input="selectTab"> -->
            <v-tabs
              icons-and-text
              centered
              dark
              color="primary"
              class="elevation-2"
            >
              <!-- <v-tabs-bar> -->
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1" @click="selectTab('tab-1')">
                <v-icon>airline_seat_recline_normal</v-icon>
                MISSIONS
              </v-tab>

              <v-tab href="#tab-2" @click="selectTab('tab-2')">
                <v-icon>description</v-icon>
                DOCUMENTS
              </v-tab>

              <v-tab href="#tab-3" @click="selectTab('tab-3')">
                <v-icon>description</v-icon>
                ADMINISTRATIF
              </v-tab>
              <v-tab href="#tab-4" @click="selectTab('tab-4')">
                <v-icon>local_gas_station</v-icon>
                CONSOMMATION
              </v-tab>
              <v-tab href="#tab-5" @click="selectTab('tab-5')">
                <v-icon>account_box</v-icon>
                INTERVENTIONS
              </v-tab>
              <v-tab href="#tab-6" @click="selectTab('tab-6')">
                <v-icon>drive_eta</v-icon>
                CONTRATS DE LOCATION
              </v-tab>
              <v-tab href="#tab-7" @click="selectTab('tab-7')">
                <v-icon>drive_eta</v-icon>
                TRAVAUX CHANTIER
              </v-tab>
               <v-tab href="#tab-8" @click="selectTab('tab-8')">
                <v-icon>account_circle</v-icon>
                CONDUCTEURS
              </v-tab>
              <!-- </v-tabs-bar> -->

              <!-- MISSIONS -->
              <v-tab-item id="tab-1">
                <v-card-text>
                  <v-flex xs3>
                    <el-col :span="2">
                      <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                      >
                        <p>Veuillez choisir le format d'impression ?</p>
                        <div style="text-align: right; margin: 0">
                          <el-button
                            type="success"
                            size="mini"
                            @click="imprimeListeHisMissionVeh('PDF')"
                            >PDF</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="imprimeListeHisMissionVeh('EXC')"
                            >EXCEL</el-button
                          >
                        </div>
                      </el-popover>
                      <div>
                        <el-button
                          v-popover:popover5
                          type="warning"
                          :disabled="disabledBtnMiss"
                          icon="el-icon-printer"
                          >Imprimer la liste
                        </el-button>
                      </div>
                    </el-col>
                  </v-flex>
                  <br /><br /><br />

                  <!-- MISSION EN COURS -->
                  <v-layout row v-if="mission.length != 0">
                    <v-flex md5>
                      <p align="center">
                        <v-chip
                          text-color="white"
                          label
                          color="primary"
                          style="width: 100%; font-size: 22px"
                        >
                          MISSION EN COURS
                        </v-chip>
                      </p>
                    </v-flex>
                    <v-flex md10>
                      <p align="center">
                        <v-chip
                          text-color="white"
                          label
                          color="green"
                          style="width: 100%; font-size: 22px"
                        >
                          MOTIF : {{ mission.activite }} DATE DE DEPART :
                          {{ mission.dateSorti }}
                        </v-chip>
                      </p>
                    </v-flex>
                  </v-layout>

                  <!-- INFO SUR CONDUCTEUR ACTUEL -->
                  <v-layout
                    row
                    v-if="mission.length != 0 && mission.nomPrenom != ''"
                  >
                    <v-flex md3>
                      <v-avatar
                        :tile="true"
                        size="180px"
                        color="grey lighten-4"
                      >
                        <img
                          v-if="!mission.urlCond"
                          src="/static/avatar-conducteur.png"
                          alt="avatar"
                        />
                        <img v-else :src="mission.urlCond" alt="avatar" />
                      </v-avatar>
                    </v-flex>
                    <v-flex md9>
                      <v-layout row>
                        <v-flex md4>
                          <p><b>MATRICULE : </b> {{ mission.matricule }}</p>
                          <p>
                            <b>NOM ET PRENOMS : </b> {{ mission.nomPrenom }}
                          </p>
                          <p>
                            <b>DATE DE NAISSANCE : </b> {{ mission.dateNais }}
                          </p>
                          <p>
                            <b>DATE D'EMBAUCHE : </b> {{ mission.dateEmbauche }}
                          </p>
                        </v-flex>

                        <v-flex md4>
                          <p>
                            <b>TYPE DE PEMIS : </b> {{ mission.typePermis }}
                          </p>
                          <p><b>N° DE PERMIS : </b> {{ mission.numPermis }}</p>
                          <p>
                            <b>DATE DE VALIDITE DU PERMIS : </b>
                            {{ mission.dateValid }}
                          </p>
                          <p><b>FONCTION : </b> {{ mission.fonction }}</p>
                        </v-flex>

                        <v-flex md4>
                          <p><b>CONTACT N°1 : </b> {{ mission.tel1 }}</p>
                          <p><b>CONTACT N°2 : </b> {{ mission.tel2 }}</p>
                          <p><b>ADRESSE : </b> {{ mission.adresse }}</p>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <br />

                  <!-- HISTORIQUE DES MISSIONS -->
                  <v-layout row v-if="itemsCond.length != 0">
                    <data-tables :data="itemsCond" style="width: 100%">
                      <el-table-column prop="demandeur" label="Demandeur">
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="primary">
                            {{ scope.row.demandeur }} fonction :
                            {{ scope.row.fonctionDem }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="activite" label="Mission">
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="primary"
                          >
                            {{ scope.row.activite }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="date" label="Date début et fin">
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="orange">
                            {{ scope.row.debut }} - {{ scope.row.fin }}
                          </v-chip>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </v-layout>
                </v-card-text>
              </v-tab-item>
              <!--MISSIONS-->

              <!-- DOCUMENTS -->
              <v-tab-item id="tab-2">
                <v-card-text>
                  <v-flex xs3>
                    <el-col :span="2">
                      <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                      >
                        <p>Veuillez choisir le format d'impression ?</p>
                        <div style="text-align: right; margin: 0">
                          <el-button
                            type="success"
                            size="mini"
                            @click="imprimeListeHisDocVeh('PDF')"
                            >PDF</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="imprimeListeHisDocVeh('EXC')"
                            >EXCEL</el-button
                          >
                        </div>
                      </el-popover>
                      <div>
                        <el-button
                          v-popover:popover5
                          type="warning"
                          :disabled="disabledBtnDoc"
                          icon="el-icon-printer"
                          >Imprimer la liste
                        </el-button>
                      </div>
                    </el-col>
                  </v-flex>
                  <br /><br /><br />

                  <v-layout row v-if="itemsDoc.length != 0">
                    <data-tables :data="itemsDoc" style="width: 100%">
                      <el-table-column prop="libelle" label="Libellé">
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="primary">
                            {{ scope.row.libelle }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="description" label="Description">
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="primary"
                          >
                            {{ scope.row.description }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="fichier" label="Documents">
                        <template slot-scope="scope">
                          <v-btn
                            outline
                            small
                            fab
                            @click="imprimeFic(scope.row.fichier)"
                            color="indigo"
                          >
                            <v-icon>photo_album</v-icon>
                          </v-btn>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </v-layout>
                </v-card-text>
              </v-tab-item>

              <!-- ADMIN -->
              <v-tab-item id="tab-3">
                <v-card-text fluid grid-list-md>
                  <v-layout row>
                    <!--ASSURANCCE-->
                    <v-flex md6>
                      <v-flex xs3>
                        <el-col :span="2">
                          <el-popover
                            ref="popover5"
                            placement="top"
                            width="180"
                            trigger="hover"
                          >
                            <p>Veuillez choisir le format d'impression ?</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                type="success"
                                size="mini"
                                @click="imprimeListeHisAdminAssuranceVeh('PDF')"
                                >PDF</el-button
                              >
                              <el-button
                                type="primary"
                                size="mini"
                                @click="imprimeListeHisAdminAssuranceVeh('EXC')"
                                >EXCEL</el-button
                              >
                            </div>
                          </el-popover>
                          <div>
                            <el-button
                              v-popover:popover5
                              type="warning"
                              :disabled="disabledBtnAdminAssu"
                              icon="el-icon-printer"
                              >Imprimer la liste
                            </el-button>
                          </div>
                        </el-col>
                      </v-flex>
                      <br /><br />

                      <v-chip label color="primary" text-color="white">
                        ASSURANCE
                      </v-chip>
                      <v-chip label color="orange" text-color="white">
                        MONTANT TOTAL : {{ mntTotAssur }} FCFA
                      </v-chip>

                      <data-tables :data="itemsDocAss" style="width: 100%">
                        <el-table-column prop="numPolice" label="N° Police">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="primary">
                              {{ scope.row.numPolice }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="numAttes" label="N° Attestation">
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                            >
                              {{ scope.row.numAttes }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <!-- <el-table-column prop="duree" label="Durée">
                                                        <template slot-scope="scope">
                                                            <v-chip label text-color="white" color="indigo">
                                                                {{scope.row.duree}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column> -->
                        <el-table-column prop="dateDbtReel" label="Date debut">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="indigo">
                              {{ scope.row.dateDbtReel }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="dateFnReel" label="Date fin">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="indigo">
                              {{ scope.row.dateFnReel }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="mntAssurReel" label="Montant">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="orange">
                              {{ scope.row.mntAssur }} FCFA
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column label="Action">
                          <template slot-scope="scope">
                            <div class="text-xs-center">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  @click="editAssu(scope.row)"
                                  fab
                                  dark
                                  small
                                  color="primary"
                                >
                                  <v-icon dark>edit</v-icon>
                                </v-btn>
                                Modifier
                              </v-tooltip>
                               <v-tooltip top v-if="scope.row.statut == false">
                                <v-btn
                                  slot="activator"
                                  @click.stop="
                                    dialogSuprAssu = true;
                                    idAssu = scope.row.id;
                                  "
                                  fab
                                  dark
                                  small
                                  color="red"
                                >
                                  <v-icon dark>delete</v-icon>
                                </v-btn>
                                Supprimer
                              </v-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </v-flex>
                    <!-- FIN ASSURANCCE-->

                    <!--VIGNETTES-->
                    <v-flex md6>
                      <v-flex xs3>
                        <el-col :span="2">
                          <el-popover
                            ref="popover5"
                            placement="top"
                            width="180"
                            trigger="hover"
                          >
                            <p>Veuillez choisir le format d'impression ?</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                type="success"
                                size="mini"
                                @click="imprimeListeHisAdminVidangeVeh('PDF')"
                                >PDF</el-button
                              >
                              <el-button
                                type="primary"
                                size="mini"
                                @click="imprimeListeHisAdminVidangeVeh('EXC')"
                                >EXCEL</el-button
                              >
                            </div>
                          </el-popover>
                          <div>
                            <el-button
                              v-popover:popover5
                              type="warning"
                              :disabled="disabledBtnAdminVign"
                              icon="el-icon-printer"
                              >Imprimer la liste
                            </el-button>
                          </div>
                        </el-col>
                      </v-flex>
                      <br /><br />

                      <v-chip label color="primary" text-color="white">
                        VIDANGES
                      </v-chip>
                      <v-chip label color="orange" text-color="white">
                        MONTANT TOTAL : {{ mntTotVid }} FCFA
                      </v-chip>

                      <data-tables :data="itemsDocVig" style="width: 100%">
                        <el-table-column prop="numero" label="N° Vidange">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="primary">
                              {{ scope.row.numero }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="dateDebt" label="Date debut">
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                            >
                              {{ scope.row.dateDebt }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="dateRen"
                          label="Date de renouvellement "
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                            >
                              {{ scope.row.dateRen }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="montant" label="Montant">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="orange">
                              {{ scope.row.montSepar }} FCFA
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column label="Action">
                          <template slot-scope="scope">
                            <div class="text-xs-center">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  @click="editVign(scope.row)"
                                  fab
                                  dark
                                  small
                                  color="primary"
                                >
                                  <v-icon dark>edit</v-icon>
                                </v-btn>
                                Modifier
                              </v-tooltip>
                                <v-tooltip top v-if="scope.row.statut == false">
                                <v-btn
                                  slot="activator"
                                  @click.stop="
                                    dialogSuprVign = true;
                                    idVign = scope.row.id;
                                  "
                                  fab
                                  dark
                                  small
                                  color="red"
                                >
                                  <v-icon dark>delete</v-icon>
                                </v-btn>
                                Supprimer
                              </v-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </v-flex>
                    <!-- FIN VIGNETTES-->
                  </v-layout>

                  <v-layout row>
                    <!--VISITES TECHNIQUES-->
                    <v-flex md6>
                      <v-flex xs3>
                        <el-col :span="2">
                          <el-popover
                            ref="popover5"
                            placement="top"
                            width="180"
                            trigger="hover"
                          >
                            <p>Veuillez choisir le format d'impression ?</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                type="success"
                                size="mini"
                                @click="imprimeListeHisAdminVisiteVeh('PDF')"
                                >PDF</el-button
                              >
                              <el-button
                                type="primary"
                                size="mini"
                                @click="imprimeListeHisAdminVisiteVeh('EXC')"
                                >EXCEL</el-button
                              >
                            </div>
                          </el-popover>
                          <div>
                            <el-button
                              v-popover:popover5
                              type="warning"
                              :disabled="disabledBtnAdminVisit"
                              icon="el-icon-printer"
                              >Imprimer la liste
                            </el-button>
                          </div>
                        </el-col>
                      </v-flex>
                      <br /><br />

                      <v-chip label color="primary" text-color="white">
                        VISITES TECHNIQUES
                      </v-chip>
                      <v-chip label color="orange" text-color="white">
                        MONTANT TOTAL : {{ mntTotVistech }} FCFA
                      </v-chip>

                      <data-tables :data="itemsDocVis" style="width: 100%">
                        <el-table-column prop="numero" label="Référence">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="primary">
                              {{ scope.row.numero }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="dateDebut" label="Date début">
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                            >
                              {{ scope.row.dateDebut }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="dateFin" label="Date fin">
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                            >
                              {{ scope.row.dateFin }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="montant" label="Montant">
                          <template slot-scope="scope">
                            <v-chip label text-color="white" color="orange">
                              {{ scope.row.montSepar }} FCFA
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column label="Action">
                          <template slot-scope="scope">
                            <div class="text-xs-center">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  @click="editVisit(scope.row)"
                                  fab
                                  dark
                                  small
                                  color="primary"
                                >
                                  <v-icon dark>edit</v-icon>
                                </v-btn>
                                Modifier
                              </v-tooltip>
                              <v-tooltip top v-if="scope.row.statut == false">
                                <v-btn
                                  slot="activator"
                                  @click.stop="
                                    dialogSuprVisit = true;
                                    idVisit = scope.row.id;
                                  "
                                  fab
                                  dark
                                  small
                                  color="red"
                                >
                                  <v-icon dark>delete</v-icon>
                                </v-btn>
                                Supprimer
                              </v-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </v-flex>
                    <!-- FIN VISITES TECHNIQUES -->
                  </v-layout>
                </v-card-text>
              </v-tab-item>
              <!-- ADMIN -->

              <!-- CONSOMMATION -->
              <v-tab-item id="tab-4">
                <v-card-text>
                  <v-flex xs3>
                    <el-col :span="2">
                      <el-popover
                        ref="popover4"
                        placement="top"
                        width="180"
                        trigger="hover"
                      >
                        <p>Veuillez choisir le format d'impression ?</p>
                        <div style="text-align: right; margin: 0">
                          <el-button
                            type="success"
                            size="mini"
                            @click="imprimeListeHisAdminConsoVeh('PDF')"
                            >PDF</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="imprimeListeHisAdminConsoVeh('EXC')"
                            >EXCEL</el-button
                          >
                        </div>
                      </el-popover>
                      <div>
                        <el-button
                          v-popover:popover4
                          type="warning"
                          :disabled="disabledBtnAdminConso"
                          icon="el-icon-printer"
                          >Imprimer la liste
                        </el-button>
                      </div>
                    </el-col>
                  </v-flex>
                  <br /><br />

                  <v-chip label color="primary" text-color="white">
                    VISITES TECHNIQUES
                  </v-chip>
                  <br />
                  <v-chip label color="orange" text-color="white">
                    MONTANT TOTAL : {{ mntTotCons }} FCFA
                  </v-chip>
                  <v-chip label color="orange" text-color="white">
                    QUANTITE CONSOMME : {{ quantTotCons }} L
                  </v-chip>
                  <v-chip label color="orange" text-color="white">
                    DISTANCE PARCOURUE : {{ distParcTot }} KM
                  </v-chip>

                  <data-tables :data="itemsCons" style="width: 100%">
                    <el-table-column prop="station" label="Station">
                      <template slot-scope="scope">
                        <v-chip label text-color="white" color="primary">
                          {{ scope.row.station }}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="carburant" label="Carburant">
                      <template slot-scope="scope">
                        <v-chip label text-color="white" color="primary">
                          {{ scope.row.carburant }}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="quantite" label="Quantité">
                      <template slot-scope="scope">
                        <v-chip
                          outline
                          label
                          text-color="primary"
                          color="primary"
                        >
                          {{ scope.row.quantite }}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dateCons" label="Date">
                      <template slot-scope="scope">
                        <v-chip label text-color="white" color="indigo">
                          {{ scope.row.dateCons }}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="montant" label="Montant">
                      <template slot-scope="scope">
                        <v-chip label text-color="white" color="orange">
                          {{ scope.row.montant }} FCFA
                        </v-chip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-card-text>
              </v-tab-item>
              <!-- CONSOMMATION -->

              <!-- interventions -->
              <v-tab-item id="tab-5">
                <v-card-text>
                  <v-flex xs3>
                    <el-col :span="2">
                      <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                      >
                        <p>Veuillez choisir le format d'impression ?</p>
                        <div style="text-align: right; margin: 0">
                          <el-button
                            type="success"
                            size="mini"
                            @click="imprimeListeHisAdminInterVeh('PDF')"
                            >PDF</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="imprimeListeHisAdminInterVeh('EXC')"
                            >EXCEL</el-button
                          >
                        </div>
                      </el-popover>
                      <div>
                        <el-button
                          v-popover:popover5
                          type="warning"
                          :disabled="disabledBtnAdminInter"
                          icon="el-icon-printer"
                          >Imprimer la liste
                        </el-button>
                      </div>
                    </el-col>
                  </v-flex>
                  <br /><br />

                  <v-chip label color="primary" text-color="white">
                    INTERVENTION
                  </v-chip>
                  <v-chip label color="orange" text-color="white">
                    MONTANT TOTAL : {{ mntTotInterv }} FCFA
                  </v-chip>

                  <data-tables :data="itemsInterv" style="width: 100%">
                    <el-table-column
                      prop="vehicule"
                      label="Véhicule"
                      fixed="left"
                    >
                      <template slot-scope="scope">
                        <v-chip label text-color="white" color="primary">
                          {{ scope.row.vehicule }}
                          <v-icon right>directions_car</v-icon>
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="date" label="Date">
                      <template slot-scope="scope">
                        <v-chip
                          outline
                          label
                          text-color="primary"
                          color="primary"
                        >
                          {{ scope.row.date }}
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="Type">
                      <template slot-scope="scope">
                        <v-chip
                          v-if="scope.row.type == 'Curative'"
                          label
                          text-color="white"
                          color="red"
                        >
                          CURATIVE
                        </v-chip>
                        <v-chip v-else label text-color="white" color="orange">
                          PREVENTIVE
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="demandeur"
                      label="Demandeur"
                    ></el-table-column>
                    <el-table-column prop="etat" label="Etat / Etape">
                      <template slot-scope="scope">
                        <v-chip
                          v-if="scope.row.etat == 0"
                          label
                          text-color="white"
                          color="primary"
                        >
                          EN ATTENTE DE VALIDATION
                        </v-chip>
                        <v-chip
                          v-else-if="scope.row.etat == 1"
                          label
                          text-color="white"
                          color="primary"
                        >
                          EN ATTENTE DE DIAGNOSTIQUE
                        </v-chip>
                        <v-chip
                          v-else-if="scope.row.etat == 2"
                          label
                          text-color="white"
                          color="red"
                        >
                          INTERVENTION REFUSE
                        </v-chip>
                        <v-chip
                          v-else-if="scope.row.etat == 3"
                          label
                          text-color="white"
                          color="green"
                        >
                          DEVIS VALIDE
                        </v-chip>
                        <v-chip
                          v-else-if="scope.row.etat == 4"
                          label
                          text-color="white"
                          color="red"
                        >
                          DIVIS REFUSE
                        </v-chip>
                        <v-chip
                          v-else-if="scope.row.etat == 5"
                          label
                          text-color="white"
                          color="green"
                        >
                          INTERVENTION TERNIME
                        </v-chip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-card-text>
              </v-tab-item>
              <!-- interventions -->

              <!-- LOCATION -->
              <v-tab-item id="tab-6">
                <v-card-text>
                  <v-flex xs3>
                    <el-col :span="2">
                      <el-popover
                        ref="popover6"
                        placement="top"
                        width="180"
                        trigger="hover"
                      >
                        <p>Veuillez choisir le format d'impression ?</p>
                        <div style="text-align: right; margin: 0">
                          <el-button
                            type="success"
                            size="mini"
                            @click="imprimeListeHisAdminLocationVeh('PDF')"
                            >PDF</el-button
                          >
                          <el-button
                            type="primary"
                            size="mini"
                            @click="imprimeListeHisAdminLocationVeh('EXC')"
                            >EXCEL</el-button
                          >
                        </div>
                      </el-popover>
                      <div>
                        <el-button
                          v-popover:popover6
                          type="warning"
                          :disabled="disabledBtnAdminLoc"
                          icon="el-icon-printer"
                          >Imprimer la liste
                        </el-button>
                      </div>
                    </el-col>
                  </v-flex>
                  <br /><br />

                  <v-chip label color="primary" text-color="white">
                    LISTE DES CONTRATS DE LOCATION DU VEHICULE
                  </v-chip>
                  <v-chip label color="orange" text-color="white">
                    MONTANT TOTAL DES CONTRATS TERMINES :
                    {{ mntTotContrat }} FCFA
                  </v-chip>

                  <v-container fluid grid-list-md>
                    <data-tables :data="listContrat" style="width: 100%">
                      <el-table-column
                        prop="ref"
                        label="Référence"
                        width="100"
                        fixed="left"
                      ></el-table-column>

                      <el-table-column prop="client" label="Client" width="180">
                        <template slot-scope="scope">
                          <v-chip text-color="white" color="primary">
                            {{ scope.row.client }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="dateD"
                        label="Date début et Fin"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            label
                            text-color="primary"
                            color="primary"
                          >
                            {{ scope.row.dateD }} - {{ scope.row.dateF }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="montantTotal"
                        label="Montant"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="orange">
                            {{ scope.row.montantTotalFormat }} FCFA
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="etat" label="Type" width="160">
                        <template slot-scope="scope">
                          <v-chip
                            v-if="scope.row.etat == 0"
                            label
                            text-color="white"
                            color="orange"
                          >
                            RESERVE
                          </v-chip>
                          <v-chip
                            v-else-if="scope.row.etat == 1"
                            label
                            text-color="white"
                            color="green"
                          >
                            ACTIVE
                          </v-chip>
                          <v-chip
                            v-else-if="scope.row.etat == 2"
                            label
                            text-color="white"
                            color="red"
                          >
                            TERMINE
                          </v-chip>
                          <v-chip
                            v-else-if="scope.row.etat == 3"
                            label
                            text-color="white"
                            color="red"
                          >
                            RESILIE
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column label="Action" fixed="right" width="200">
                        <template slot-scope="scope">
                          <div class="text-xs-center">
                            <v-tooltip top>
                              <v-btn
                                v-if="scope.row.etat != 0"
                                slot="activator"
                                @click="impmerFacture(scope.row)"
                                fab
                                dark
                                small
                                color="orange"
                              >
                                <v-icon dark>print</v-icon>
                              </v-btn>
                              Imprimer
                            </v-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </v-container>
                </v-card-text>
              </v-tab-item>
              <!-- LOCATION -->

              <!-- TRAVAUX -->
              <v-tab-item id="tab-7">
                <v-card-text>
                  <VehiculeBesoin
                    :listeBesoinsVeh="listeBesoinsVehValid"
                  ></VehiculeBesoin>
                </v-card-text>
              </v-tab-item>
              <!-- TRAVAUX -->


                 <!-- CONDUCTEUR -->
              <v-tab-item id="tab-8">
                <v-card-text>
                  <br /><br />
                   <v-chip label color="primary" text-color="white">
                    LISTE DES CONDUCTEURS
                  </v-chip>
                   <v-flex xs12 class="text-xs-right">
                    <v-tooltip top>
                        <v-btn
                          slot="activator"
                          icons
                          color="primary"
                          @click.stop="newAttrCondu"
                          dark
                          >Ajouter <v-icon right>add</v-icon></v-btn
                        >
                        Affecter un vehicule a ce conducteur
                      </v-tooltip>
                  </v-flex>
                  <v-container fluid grid-list-md>
                  <data-tables :data="listConducteur" style="width: 100%">
                      <el-table-column prop="url" label="Photo" width="100">
                        <template slot-scope="scope">
                          <v-avatar>
                            <img
                              v-if="scope.row.url"
                              :src="scope.row.url"
                              class="lazy"
                              alt=""
                            />
                            <img
                              v-else
                              src="/static/avatar-conducteur.png"
                              class="lazy"
                              alt=""
                            />
                          </v-avatar>
                        </template>
                      </el-table-column>
                      <el-table-column prop="nomPren" label="Conducteur" width="300">
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="primary">
                            {{ scope.row.nomPren }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="date"
                        label="Date validité du permis"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <v-chip label text-color="white" color="primary">
                            {{ scope.row.dateValPmi }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column prop="montant" label="Disponibilité">
                        <template slot-scope="scope">
                          <v-chip
                            v-if="scope.row.disponibilite === 'Disponible'"
                            color="green"
                            text-color="white"
                          >
                            <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                            {{ scope.row.disponibilite }}
                          </v-chip>
                          <v-chip
                            v-if="scope.row.disponibilite === 'En activite'"
                            color="orange"
                            text-color="white"
                          >
                            <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                            {{ scope.row.disponibilite }}
                          </v-chip>
                          <v-chip
                            v-if="scope.row.disponibilite === 'Absent'"
                            color="red"
                            text-color="white"
                          >
                            <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                            {{ scope.row.disponibilite }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column label="Action">
                        <template slot-scope="scope">
                          <div class="text-xs-center">
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                @click="ficheConducteur(scope.row)"
                                fab
                                dark
                                small
                                color="green"
                              >
                                <v-icon dark>folder_open</v-icon>
                              </v-btn>
                              Détails
                            </v-tooltip>
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                @click.stop="
                                  dialogSuprCond = true;
                                  idConducteur = scope.row.idCond;
                                "
                                fab
                                dark
                                small
                                color="red"
                              >
                                <v-icon dark>delete</v-icon>
                              </v-btn>
                              Supprimer
                            </v-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </v-container>
                </v-card-text>
              </v-tab-item>
              <!-- CONDUCTEUR -->

            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>
    </el-card>

   <!-- MODAL SUPPRESSION ASSURANCE -->
    <v-dialog
      v-model="dialogSuprAssu"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette assurance ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprAssu = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteAssu" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION VIDANGE -->
    <v-dialog
      v-model="dialogSuprVign"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette vidange ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprVign = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteVign" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION VISITE -->
    <v-dialog
      v-model="dialogSuprVisit"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette visite technique ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprVisit = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteVisit" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VEHICULE -->
    <v-dialog
      v-model="dialogAjoutVeh"
      :persistent="true"
      max-width="80%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="primary">
          <v-toolbar-title> <span>Modfier un véhicule </span> </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogAjoutVeh = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            id="formVehicule"
            ref="formVehicule"
            v-model="valid"
            lazy-validation
            enctype="multipart/form-data"
          >
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                  >Marque</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2"
                  >Générale</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <!--Formulaire Marque-->
                  <v-container fluid grid-list-md>
                    <v-layout row>
                      <v-flex md4>
                        <v-layout row>
                          <v-flex md6>
                            <v-avatar
                              :tile="true"
                              size="140px"
                              height="120px"
                              color="grey lighten-4"
                            >
                              <img :src="imageVeh" alt="avatar" />
                            </v-avatar>

                            <v-layout row>
                              <input
                                name="fichVeh"
                                type="file"
                                style="display:none"
                                ref="fileVeh"
                                accept="image/*"
                                @change="onFileVehPicked"
                              />
                              <v-btn
                                color="primary"
                                class="white--text"
                                required
                                @click.native="$refs.fileVeh.click()"
                              >
                                Photo vehicule
                                <v-icon right dark>cloud_upload</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-flex>

                          <v-flex md6>
                            <v-avatar
                              :tile="true"
                              size="140px"
                              height="120px"
                              color="grey lighten-4"
                            >
                              <img :src="imageCarteGris" alt="avatar" />
                            </v-avatar>

                            <v-layout row>
                              <input
                                name="fichCarteGris"
                                type="file"
                                style="display:none"
                                ref="fileCarteGris"
                                accept="image/*"
                                @change="onFileCartePicked"
                              />
                              <v-btn
                                color="primary"
                                class="white--text"
                                required
                                @click.native="$refs.fileCarteGris.click()"
                              >
                                Carte grise
                                <v-icon right dark>cloud_upload</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex md8>
                        <v-layout row>
                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >Catégorie de véhicule *</span
                              >
                              <el-select
                                allow-create
                                @change="chargeMarque"
                                filterable
                                clearable
                                v-model="formVehicule.categorieId"
                                placeholder="Catégorie de véhicule"
                                style="width:100%"
                              >
                                <el-option
                                  v-for="item in listCategorie"
                                  :key="item.id"
                                  :label="item.libelle"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>

                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >Marque concerné *</span
                              >
                              <el-select
                                allow-create
                                @change="chargeModele"
                                filterable
                                clearable
                                v-model="formVehicule.marqueId"
                                placeholder="Marque concerné"
                                style="width:100%"
                              >
                                <el-option
                                  v-for="item in listMarque"
                                  :key="item.id"
                                  :label="item.libelle"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >Série du véhicule *</span
                              >
                              <el-select
                                @change="selectSerie"
                                allow-create
                                filterable
                                clearable
                                v-model="formVehicule.serieId"
                                placeholder="Série du véhicule"
                                style="width:100%"
                              >
                                <el-option
                                  v-for="item in listSerie"
                                  :key="item.id"
                                  :label="item.libelle"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>

                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >Modèle concerné *</span
                              >
                              <el-select
                                allow-create
                                @change="chargeSerie"
                                filterable
                                clearable
                                v-model="formVehicule.modeleId"
                                placeholder="Modele concerné"
                                style="width:100%"
                              >
                                <el-option
                                  v-for="item in listModele"
                                  :key="item.id"
                                  :label="item.libelle"
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >Immatriculation *</span
                              >
                              <el-input
                                name="matricule"
                                placeholder="Immatriculation"
                                v-model="formVehicule.matricule"
                                required
                              ></el-input>
                            </div>
                          </v-flex>
                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration">N° du chassis *</span>
                              <el-input
                                name="numChassis"
                                placeholder="N° du chassis"
                                v-model="formVehicule.numChassis"
                                required
                              ></el-input>
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex md6>
                            <div class="block">
                              <span class="demonstration"
                                >N° de la carte grsie *</span
                              >
                              <el-input
                                name="numCarteGris"
                                placeholder="N° du chassis"
                                v-model="formVehicule.numCarteGris"
                                required
                              ></el-input>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-container>

                  <v-layout row>
                    <v-btn
                      icons
                      color="orange"
                      @click="dialogAjoutVeh = false"
                      dark
                      >Annuler <v-icon right>close</v-icon></v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native="e1 = 2">
                      Continuer <v-icon dark>navigate_next</v-icon>
                    </v-btn>
                  </v-layout>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <!--Formulaire Marque-->
                  <v-container fluid grid-list-md>
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Date d'acquisition *</span
                          >
                          <el-date-picker
                            value-format="dd-MM-yyyy"
                            v-model="formVehicule.dateAqui"
                            name="dateAqui"
                            type="date"
                            placeholder="Date d'acquisition"
                            style="width:100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Type de carburant *</span>
                          <el-select
                            filterable
                            clearable
                            v-model="formVehicule.typeCarbuId"
                            placeholder="Type de carburant"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in typeCarburant"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Nombre de place *</span>
                          <el-input
                            type="number"
                            name="nbPlace"
                            placeholder="Nombre de place"
                            v-model="formVehicule.nbPlace"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Kilométrage Compteur (Km/h) *</span
                          >
                          <el-input
                            type="number"
                            name="kilometrage"
                            placeholder="Kilométrage (Km/h)"
                            v-model="formVehicule.kilometrage"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Prix d'achat </span>
                          <el-input
                            type="number"
                            name="prixAchat"
                            placeholder="Prix d'achat du vehicule "
                            v-model="formVehicule.prixAchat"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Année du vehicule </span>
                          <el-date-picker
                            value-format="yyyy"
                            v-model="formVehicule.annVeh"
                            name="annVeh"
                            type="year"
                            placeholder="Année du vehicule"
                            style="width:100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Couleur *</span>
                          <el-input
                            name="couleur"
                            placeholder="Couleur"
                            v-model="formVehicule.couleur"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration"
                            >Affecter un parc auto *</span
                          >
                          <el-select
                            filterable
                            clearable
                            v-model="formVehicule.parcId"
                            placeholder="Affecter un parc auto"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listParc"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Coût utilisation </span>
                          <el-input
                            type="number"
                            name="coutUtil"
                            placeholder="Cout d'utilisation du vehicule "
                            v-model="formVehicule.coutUtil"
                            required
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                  </v-container>

                  <v-layout row>
                    <v-btn
                      icons
                      color="orange"
                      @click="dialogAjoutVeh = false"
                      dark
                      >Annuler <v-icon right>close</v-icon></v-btn
                    >
                    <v-spacer></v-spacer>

                    <v-btn dark color="primary" @click.native="e1 = 1">
                      <v-icon dark>navigate_before</v-icon> Précédent
                    </v-btn>
                    <v-btn
                      color="primary"
                      :disabled="!formVehIsValid"
                      @click.native="createVeh(idVehModif)"
                    >
                      Ajouter <v-icon dark>add</v-icon>
                    </v-btn>
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

 <!-- MODAL SUPPRESSION CONDUCTEUR -->
    <v-dialog
      v-model="dialogSuprCond"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">Voulez-vous vraiment supprimer ce conducteur ?</h3>
          <p align="center">
            <v-btn @click.native="dialogSuprCond = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteConducteur" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

<!-- MODAL FICHE DE CONDUCTEUR -->
    <v-dialog
      persistent
      v-model="dialogFicheCond"
      :overlay="true"
      scrollable
      max-width="70%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Fiche conducteur </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogFicheCond = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-container>
            <v-layout row>
              <v-flex md4>
                <v-avatar :tile="true" size="180px" color="grey lighten-4">
                  <img
                    v-if="conducteurCourant.url == null ||conducteurCourant.url == '' "
                    src="/static/avatar-conducteur.png"
                    alt="avatar"
                  />
                  <img v-else :src="conducteurCourant.url" alt="avatar" />
                </v-avatar>
                <br />
                <p align="center">
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'Disponible'"
                      color="green"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'En activite'"
                      color="orange"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                    <v-chip
                      v-if="conducteurCourant.disponibilite === 'Absent'"
                      color="red"
                      text-color="white"
                    >
                      <v-avatar><v-icon>account_circle</v-icon></v-avatar>
                      {{ conducteurCourant.disponibilite }}
                    </v-chip>
                </p>
              </v-flex>
              <v-flex md4>
                <p><b>Matricule : </b> {{ conducteurCourant.matricule }}</p>
                <p>
                  <b>Nom et prénoms : </b> {{ conducteurCourant.nom }}
                  {{ conducteurCourant.prenom }}
                </p>
                <p>
                  <b>Date de naissance : </b> {{ conducteurCourant.dateNs }}
                </p>
                <p>
                  <b>Lieu de naissance : </b> {{ conducteurCourant.lieuNaiss }}
                </p>
                <p>
                  <b>Contacts : </b> {{ conducteurCourant.phone1 }} /
                  {{ conducteurCourant.phone2 }}
                </p>
                <p><b>Adresse : </b> {{ conducteurCourant.adresse }}</p>
              </v-flex>
              <v-flex md4>
                <p><b>Fonction : </b> {{ conducteurCourant.fonction }}</p>
                <p><b>Date d'embauche : </b> {{ conducteurCourant.dateEmb }}</p>
                <p>
                  <b>Type de permis : </b> {{ conducteurCourant.typePermis }}
                </p>
                <p>
                  <b>Numéro de permis : </b> {{ conducteurCourant.numPermis }}
                </p>
                <p>
                  <b>Date de validite du permis : </b>
                  {{ conducteurCourant.dateVp }}
                </p>
              </v-flex>
            </v-layout>
            <br />
            <v-btn color="orange" @click.stop="dialogFicheCond = false" dark
              >Fermer <v-icon right>close</v-icon></v-btn>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>


 <!-- MODAL AJOUT VEHICULE A UN CONDUCTEUR -->
    <v-dialog v-model="dialogAjoutVehiConducteur" max-width="60%" :persistent="true" :loading="loading" scrollable>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Attribuer un conducteur au vehicule {{ detailVeh.immat }} - {{ detailVeh.marque }} :
                  {{ detailVeh.modele }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVehiConducteur = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="formAttribueCondu" lazy-validation id="formAttribueCondu">
            <v-container fluid grid-list-md>
             <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Véhicule concerné</span>
                    <el-input
                          :readonly="true"
                          name="numero"
                          placeholder="Numero"
                          v-model="detailVeh.immat">
                      </el-input>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Conducteur *</span>
                    <el-select
                      v-model="formAttribueCondu.conducteur"
                      placeholder="Conducteur"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in AllConducteur"
                        :key="item.idCond"
                        :label="item.nomPren"
                        :value="item.idCond"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />
              <v-btn color="orange" @click.stop="dialogAjoutVehiConducteur = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons color="primary" @click="submitAttribution()" dark
                >Enrregistrer <v-icon right>save</v-icon></v-btn>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT ASSURANCE -->
    <v-dialog
      persistent
      v-model="dialogAjoutAssu"
      :overlay="true"
      max-width="60%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajout d'une nouvelle assurance {{ detailVeh.immat }} -
              {{ detailVeh.marque }} : {{ detailVeh.modele }}</span
            >
            <span v-if="dialogEdit"
              >Modification d'une assurance {{ detailVeh.immat }} -
              {{ detailVeh.marque }} : {{ detailVeh.modele }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutAssu = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formAssu" lazy-validation id="formAssu">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UNE NOUVELLE ASSURANCE DU VEHICULE
                  {{ detailVeh.immat }} - {{ detailVeh.marque }} :
                  {{ detailVeh.modele }}
                </v-chip>
                <v-chip
                  v-if="dialogEdit"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE L'ASSURANCE DU VEHICULE
                  {{ detailVeh.immat }} - {{ detailVeh.marque }} :
                  {{ detailVeh.modele }}
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="logoAssur" alt="avatar"/></v-avatar
                  ><br />
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileAssur"
                    accept="image/*"
                    @change="onFileImageAssurLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileAssur.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>

                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">N° Attestation *</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="attestation"
                          id="attestation"
                          placeholder="Attestation"
                          v-model="formAssu.attestation"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">N° Police *</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="police"
                          id="police"
                          placeholder="Police"
                          v-model="formAssu.police"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Montant TTC de l'assurance *</span
                        >
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          type="number"
                          min="0"
                          name="montant"
                          id="montant"
                          placeholder="Montant de l'assurance"
                          v-model="formAssu.montant"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date d'achat l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateAssu"
                          name="dateAssurance"
                          id="dateAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date d'achat de l'assurance"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Compagnie *</span>
                        <el-select
                          :disabled="assuranceCourant.statut == true"
                          v-model="selectCompagnLib"
                          placeholder="La Compagnie"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in listCompagn"
                            :key="item.idPres"
                            :label="item.libelle"
                            :value="item.idPres"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de debut de l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateDebutAssu"
                          name="dateDebutAssurance"
                          id="dateDebutAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de debut"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de fin de l'assurance *</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateFinAssu"
                          name="dateFinAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de fin"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé l'assurance *</span>
                        <el-select
                          v-model="formAssu.statut"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statut"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement</span
                        >
                        <el-date-picker
                          :readonly="assuranceCourant.statut == true"
                          v-model="formAssu.dateRenAssu"
                          id="dateRenAssurance"
                          name="dateRenAssurance"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          :readonly="assuranceCourant.statut == true"
                          name="description"
                          id="description"
                          type="textarea"
                          :rows="3"
                          v-model="formAssu.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutAssu = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitAssu()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VISITE -->
    <v-dialog
      persistent
      v-model="dialogAjoutVisit"
      max-width="60%"
      :loading="loading"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajout d'une nouvelle visite {{ detailVeh.immat }} -
              {{ detailVeh.marque }} : {{ detailVeh.modele }}</span
            >
            <span v-if="dialogEdit"
              >Modification de la visite du {{ visiteCourant.dateDebut }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVisit = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formVisite"
            lazy-validation
            id="formVisite"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UNE NOUVELLE VISITE TECHNIQUE {{ detailVeh.immat }} -
                  {{ detailVeh.marque }} : {{ detailVeh.modele }}
                </v-chip>
                <v-chip
                  v-if="dialogEdit"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE LA VISITE TECHNIQUE
                  {{ visiteCourant.dateDebut }} POUR {{ detailVeh.immat }} -
                  {{ detailVeh.marque }} : {{ detailVeh.modele }}
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="logoVisit" alt="avatar"/></v-avatar
                  ><br />
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="logoVisit"
                    accept="image/*"
                    @change="onFileImageLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.logoVisit.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>

                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Numero de la visite *</span>
                        <el-input
                          :readonly="visiteCourant.statut == true"
                          name="numero"
                          placeholder="Numero"
                          v-model="formVisite.numero"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Montant TTC*</span>
                        <el-input
                          :min="0"
                          :readonly="visiteCourant.statut == true"
                          type="number"
                          name="montant"
                          placeholder="Montant"
                          v-model="formVisite.montant"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Date de la visite *</span>
                        <el-date-picker
                          :readonly="visiteCourant.statut == true"
                          v-model="formVisite.dateDebut"
                          name="dateDebut"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de la visite"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date fin de la visite *</span
                        >
                        <el-date-picker
                          :readonly="visiteCourant.statut == true"
                          v-model="formVisite.dateFin"
                          name="dateFin"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date fin"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement
                        </span>
                        <el-date-picker
                          :readonly="visiteCourant.statut == true"
                          v-model="formVisite.dateRen"
                          name="dateRen"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé la visite *</span>
                        <el-select
                          v-model="formVisite.statut"
                          placeholder="Activé la visite"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statut"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md12>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          name="description"
                          type="textarea"
                          :rows="3"
                          v-model="formVisite.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <br />

              <v-btn color="orange" @click.stop="dialogAjoutVisit = false" dark
                >Annuler <v-icon right>close</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitVisit()" dark
                >Ajouter <v-icon right>add</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE VIGNETTE -->
    <v-dialog
      persistent
      v-model="dialogAjoutVign"
      :overlay="true"
      max-width="60%"
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajout d'une nouvelle vidange {{ detailVeh.immat }} -
              {{ detailVeh.marque }} : {{ detailVeh.modele }}</span
            >
            <span v-if="dialogEdit"
              >Modification de la vidange du {{ vidangeCourant.date }}
              {{ detailVeh.immat }} - {{ detailVeh.marque }} :
              {{ detailVeh.modele }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutVign = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formVidn" lazy-validation id="formVidn">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  v-if="dialogEdit != true"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  AJOUTER UNE NOUVELLE VIDANDE AU VEHICULE
                  {{ detailVeh.immat }} - {{ detailVeh.marque }} :
                  {{ detailVeh.modele }}
                </v-chip>
                <v-chip
                  v-if="dialogEdit"
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                >
                  MODIFICATION DE LA VIDANGE DU {{ vignetteCourant.date }}
                  {{ detailVeh.immat }} - {{ detailVeh.marque }} :
                  {{ detailVeh.modele }}
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md6>
                  <v-avatar
                    :tile="true"
                    size="140px"
                    height="120px"
                    color="grey lighten-4"
                  >
                    <img :src="logoVignet" alt="avatar" />
                  </v-avatar>
                  <br />
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileVignet"
                    accept="image/*"
                    @change="onFileImageVidangeLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileVignet.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  >
                  <br />
                </v-flex>
                <v-flex md9>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Numero de la vidange *</span
                        >
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          name="numero"
                          placeholder="Numero"
                          v-model="formVidn.numero"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Numero facture proforma</span
                        >
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          name="numFacture"
                          placeholder="Numero"
                          v-model="formVidn.numFacture"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Date de la vidange *</span>
                        <el-date-picker
                          :readonly="vidangeCourant.statut == true"
                          v-model="formVidn.dateDebt"
                          id="dateVidange"
                          name="dateVidange"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de la vidange"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Kilométrage actuel *</span>
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          type="number"
                          min:0
                          name="kiloActu"
                          placeholder="Kilométrage actuel"
                          v-model="formVidn.kiloActu"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Kilométrage prochain *</span
                        >
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          type="number"
                          min:0
                          name="kiloProch"
                          placeholder="Kilométrage prochain "
                          v-model="formVidn.kiloProch"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Montant *</span>
                        <el-input
                          :readonly="vidangeCourant.statut == true"
                          type="number"
                          name="montant"
                          placeholder="Montant"
                          v-model="formVidn.montant"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration"
                          >Date de renouvellement
                        </span>

                        <el-date-picker
                          v-model="formVidn.dateRen"
                          :readonly="vidangeCourant.statut == true"
                          id="dateRen"
                          name="dateRen"
                          value-format="dd-MM-yyyy"
                          type="date"
                          placeholder="Date de renouvellement"
                          style="width: 100%"
                        ></el-date-picker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Activé la vidange *</span>
                        <el-select
                          v-model="formVidn.statut"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in statut"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          name="description"
                          type="textarea"
                          :rows="3"
                          v-model="formVidn.description"
                          required
                          style="width: 100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogAjoutVign = false" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn icons color="primary" @click="submitVign()" dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import VehiculeBesoin from "@/components/besoin/VehiculeBesoin";
export default {
  components: { Loading, VehiculeBesoin },
  name: "FicheVehicule",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      valid: true,
      detailVeh: {},
      mission: {},
      docAttach: {},
      racourcis: [
        { path: "/parc/auto", text: "Parc auto", disabled: false },
        { path: "/parc/auto/flotte", text: "Flotte", disabled: false },
        { path: "/", text: "Fiche vehicule", disabled: false }
      ],
      idVeh: this.$route.params.id,
      dialogAjoutVeh: false,
      dialogSuprVign: false,
      idAssu: "",
      idVign: "",
      idVisit: "",
      dialogSuprVisit: false,
      dialogSuprAssu: false,
      dialogAjoutAssu: false,
      dialogAjoutVisit: false,
      dialogAjoutVign: false,
      dialogEdit: false,
      dialogSuprCond: false,
      active: null,
      logoAssur: "/static/img-doc.png",
      logoVisit: "/static/img-doc.png",
      formCond: {},
      itemsCond: [],
      itemsDoc: [],
      itemsDocAss: [],
      listConducteur:[],
      mntTotAssur: 0,
      mntTotVig: 0,
      mntTotVid: 0,
      mntTotVistech: 0,
      itemsDocVig: [],
      itemsDocVis: [],
      itemsCons: [],
      mntTotCons: 0,
      quantTotCons: 0,
      distParcTot: 0,
      itemsInterv: [],
      listContrat: [],
      logoVignet: "",
      nbrContratExpireDay: 0,
      mntTotInterv: 0,
      messageAlert: "",
      formAssu: {
        attestation: "",
        police: "",
        montant: "",
        description: "",
        dateAssu: null,
        dateDebutAssu: null,
        dateFinAssu: null,
        dateRenAssu: null
      },
      formVisite: {
        libelle: "",
        numero: "",
        dateDebut: null,
        dateFin: null,
        dateRen: null,
        montant: "",
        description: "",
        vehMat: ""
      },
      formVidn: {
        numero: "",
        date: null,
        dateDebt: null,
        dateRen: null,
        montant: "",
        document: "",
        vehMat: "",
        statut: ""
      },
      selectCompagnLib: "",
      assuranceCourant: [],
      statut: [{ value: 1, label: "Activé" }, { value: 0, label: "Desactivé" }],
      statutVign: [
        {
          value: 1,
          label: "Activé"
        },
        {
          value: 0,
          label: "Desactivé"
        }
      ],
      listCompagn: [],
      visiteCourant: [],
      vignetteCourant: [],
      listMarque: [],
      listCategorie: [],
      typeCarburant: [],
      vidangeCourant: [],

      idConducteur: "",
      listModele: [],
      listSerie: [],
      e1: 0,
      imageCarteGris: "/static/img-doc.png",
      imageVeh: "/static/car_avatar.png",
      formVehicule: {},
      listParc: [],
      mntTotContrat: 0,
      nbAssurAbs: 0,
      nbAssurAexp: 0,
      nbVisiteTechAbs: 0,
      nbVisiteTechExp: 0,
      nbVignetteAbs: 0,
      nbVignetteExp: 0,
      disabledBtnDoc: false,
      disabledBtnMiss: false,
      disabledBtnAdminAssu: false,
      disabledBtnAdminVign: false,
      disabledBtnAdminVisit: false,
      disabledBtnAdminConso: false,
      disabledBtnAdminInter: false,
      disabledBtnAdminLoc: false,
      dialogAjoutVehiConducteur: false,
      dialogFicheCond: false,
      AllConducteur:[],
      conducteurCourant:[],
      formAttribueCondu:{
        conducteur:'',
        vehicule:''
      },
      //ONGLET TRAVAUX
      listeBesoinsVehValid: []
    };
  },
  computed: {
    formVehIsValid() {
      return (
        this.formVehicule.marqueId != "" &&
        this.formVehicule.modeleId != "" &&
        this.formVehicule.serieId != "" &&
        this.formVehicule.matricule != null &&
        this.formVehicule.numChassis != null &&
        this.formVehicule.numCarteGris != null &&
        this.formVehicule.typeCarbuId != null &&
        this.formVehicule.kilometrage != null &&
        this.formVehicule.parcId != null
      );
    }
  },
  methods: {
    loadBesoinVehValider() {
      this.loading = true;
      let url = this.domaine + "besoin/valider/vehicule/" + this.idVeh;
      this.$http.get(url).then(
        response => {
          this.listeBesoinsVehValid = response.body.besoins;
          console.log("liste besoin valider ", response.body.besoins);
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors du chargement des vehicules affectés au besoins"
          );
        }
      );
    },
    newAttrCondu(){
      this.loadListConducteur()
      this.dialogAjoutVehiConducteur = true;
      this.formAttribueCondu.conducteur = ''
    },
    imprimeInfoVeh() {
      console.log("idVehic");

      let url = this.domaine + "tabParcauto/impression/vehicule/" + this.idVeh;
      window.open(url);
    },
    imprimeListeHisDocVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/document/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/document/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisMissionVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/mission/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/mission/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminAssuranceVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-assurance/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-assurance/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminVidangeVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-vidange/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-vidange/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminVisiteVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-visite/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-visite/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminConsoVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-conso/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-conso/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminInterVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "tabParcauto/imprimerPDF/historique/" +
          idVeh +
          "/admin-interv/vehicule";
      } else {
        url =
          this.domaine +
          "tabParcauto/imprimerEXC/historique/" +
          idVeh +
          "/admin-interv/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminLocationVeh(type) {
      let idVeh = this.idVeh;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "contrat/imprimerPDF/historique/" +
          idVeh +
          "/admin-location/vehicule";
      } else {
        url =
          this.domaine +
          "contrat/imprimerEXC/historique/" +
          idVeh +
          "/admin-location/vehicule";
      }
      window.open(url);
    },
    ficheConducteur(ligne) {
      this.dialogFicheCond = true;
      this.conducteurCourant = ligne;
    },

    loadPage() {
      this.loading = true;
    },
    chargeMarque(idCat) {
      if (idCat != "" && !isNaN(idCat)) {
        //chargement des modele lie a la categorie
        this.loadMarque(idCat);
      } else {
        this.formVehicule.marqueId = "";
        this.listSerie = [];
        this.formVehicule.serieId = "";
        this.formVehicule.modeleId = "";
      }
    },
    chargeModele(idMarq) {
      if (idMarq != "" && !isNaN(idMarq)) {
        //chargement des modele lie a la categorie
        this.loadModele(idMarq);
      } else {
        this.listMarque.push({ id: idMarq, libelle: idMarq, text: idMarq });
      }
    },
    chargeSerie(idMod) {
      if (idMod != "" && !isNaN(idMod)) {
        //chargement des modele lie a la categorie
        this.loadSerie(idMod);
      } else {
        this.listModele.push({ id: idMod, libelle: idMod, text: idMod });
      }
    },
    selectSerie(idSerie) {
      if (idSerie != "" && !isNaN(idSerie)) {
      } else {
        this.listSerie.push({ id: idSerie, libelle: idSerie, text: idSerie });
      }
    },
    selectTab(idtab) {
      console.log("idtab");
      this.loading = true;
      switch (idtab) {
        case "tab-1":
          {
            let url = this.domaine + "tabParcauto/utilisation/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.mission = resp.body.mission;
                this.itemsCond = resp.body.utilisations;
                if (
                  this.itemsCond === undefined ||
                  this.itemsCond.length == 0
                ) {
                  this.disabledBtnMiss = true;
                } else {
                  this.disabledBtnMiss = false;
                }
                this.loading = false;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des donnees d'utilisations"
                );
                this.loading = false;
              }
            );
          }
          break;
        case "tab-2":
          {
            let url = this.domaine + "tabParcauto/docattach/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsDoc = resp.body;
                if (this.itemsDoc === undefined || this.itemsDoc.length == 0) {
                  this.disabledBtnDoc = true;
                } else {
                  this.disabledBtnDoc = false;
                }
                this.loading = false;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des documents attaches au vehicule"
                );
                this.loading = false;
              }
            );
          }
          break;
        case "tab-3":
          {
            let url = this.domaine + "tabParcauto/docadmin/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsDocAss = resp.body.docsassur;
                if (
                  this.itemsDocAss === undefined ||
                  this.itemsDocAss.length == 0
                ) {
                  this.disabledBtnAdminAssu = true;
                } else {
                  this.disabledBtnAdminAssu = false;
                }
                this.itemsDocVig = resp.body.docsvig;
                if (
                  this.itemsDocVig === undefined ||
                  this.itemsDocVig.length == 0
                ) {
                  this.disabledBtnAdminVign = true;
                } else {
                  this.disabledBtnAdminVign = false;
                }
                this.itemsDocVis = resp.body.docsvistech;
                if (
                  this.itemsDocVis === undefined ||
                  this.itemsDocVis.length == 0
                ) {
                  this.disabledBtnAdminVisit = true;
                } else {
                  this.disabledBtnAdminVisit = false;
                }
                this.mntTotAssur = resp.body.total.mntTotAssur;
                this.mntTotVig = resp.body.total.mntTotVig;
                this.mntTotVid = resp.body.total.mntTotVid;
                this.mntTotVistech = resp.body.total.mntTotVistech;
                this.loading = false;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des documents administratifs"
                );
                this.loading = false;
              }
            );
          }
          break;
        case "tab-4":
          {
            let url = this.domaine + "tabParcauto/consommation/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsCons = resp.body.consommation;
                if (
                  this.itemsCons === undefined ||
                  this.itemsCons.length == 0
                ) {
                  this.disabledBtnAdminConso = true;
                } else {
                  this.disabledBtnAdminConso = false;
                }
                this.mntTotCons = resp.body.total.mntTotCons;
                this.quantTotCons = resp.body.total.quantTotCons;
                this.distParcTot = resp.body.total.distParcTot;
                this.loading = false;
              },
              resp => {
                this.$message.error(
                  "erreur lors du chargement des consommations"
                );
                this.loading = false;
              }
            );
          }
          break;
        case "tab-5":
          {
            let url = this.domaine + "tabParcauto/intervention/" + this.idVeh;
            this.$http.get(url).then(
              resp => {
                this.itemsInterv = resp.body.interventions;

                if (
                  this.itemsInterv === undefined ||
                  this.itemsInterv.length == 0
                ) {
                  this.disabledBtnAdminInter = true;
                } else {
                  this.disabledBtnAdminInter = false;
                }
                this.mntTotInterv = resp.body.mntInterv;
                this.loading = false;
              },
              resp => {
                this.$message.error(
                  "Erreur lors du chargement des interventions"
                );
                this.loading = false;
              }
            );
          }
          break;
        case "tab-6":
          {
            let url = this.domaine + "contrat/vehicule/" + this.idVeh;
            this.$http.get(url).then(response => {
              if (response.body) {
                this.mntTotContrat = response.body.mntTotContrat;
                this.listContrat = response.body.contrat;
                this.nbrContratExpireDay = response.body.nbrContratExpireDay;
                this.loading = false;
                let notif = this.$vs;
                let thise = this;
                this.listContrat.forEach(function(item) {
                  //on verifi si la date de fin du contrat est passé
                  if (thise.notif === "active" && item.expire == true) {
                    notif.notify({
                      title: "CONTRAT EXPIRE",
                      text:
                        "Le contrat " +
                        item.ref +
                        " du client " +
                        item.client +
                        " a expiré depuis la date du " +
                        item.dateFFormat,
                      color: "danger",
                      position: "top-right",
                      icon: "description",
                      time: 10000,
                      click: () => {
                        thise.contratCourant = item;
                        thise.dialogShowContrat = true;
                      }
                    });
                  }
                });

                //contrat expirant aujourd'hui
                if (this.notif === "active" && this.nbrContratExpireDay != 0) {
                  this.$vs.notify({
                    title: "CONTRAT EXPIRANT AUJOURD'HUI",
                    text:
                      this.nbrContratExpireDay +
                      " Contrat (s) expire(ent) aujourd'hui.",
                    color: "rgb(58, 154, 201)",
                    position: "top-right",
                    icon: "check_box",
                    time: 10000
                  });
                }
              }
            });
          }
          break;
        case "tab-7":
          {
            this.loadBesoinVehValider();
          }
          break;
        case "tab-8":
          {
            this.loadVConducteur();
          }
          break;
        default: {
        }
      }
    },
    //enregistrement des images
    onFileImageLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoVisit = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVisit = files[0];
    },
    onFileImageVidangeLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoVignet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVignet = files[0];
    },
    //enregistrement des images
    onFileImageAssurLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoAssur = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoAssur = files[0];
    },
    loadParc() {
      let url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listParc = response.body.parc;
        }
      });
    },
    loadMarque(idCat) {
      let url = this.domaine + "parc/index/marque/cat/" + idCat;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listMarque = response.body.marque;
        }
      });
    },
    loadCategorie() {
      let url = this.domaine + "parc/index/categorie";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCategorie = response.body.categorie;
        }
      });
    },
    loadCarburant() {
      let url = this.domaine + "parc/index/carburant";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.typeCarburant = response.body.carburant;
        }
      });
    },
    loadModele(idMarq) {
      let url = this.domaine + "parc/index/modele/marque/" + idMarq;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listModele = response.body.modele;
        }
      });
    },
    loadSerie(idMod) {
      let url = this.domaine + "parc/index/serie/modele/" + idMod;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listSerie = response.body.serie;
        }
      });
    },
    loadCompagnie() {
      let url = this.domaine + "fournisseur/indexFournisseur";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCompagn = response.body.prestataire;
        }
      });
    },
    loadInfoVeh(idVeh) {
      this.loading = true;
      let url = this.domaine + "parc/vehicule/" + this.idVeh;
      this.$http.get(url).then(
        resp => {
          this.detailVeh = resp.body.vehicule;
          this.messageAlert = resp.body.alertMess;
          this.loading = false;
        },
        resp => {
          this.$message.error(
            "erreur lors du chargement des infos sur le vehicule."
          );
          this.loading = false;
        }
      );
    },
    newAssu(ligne) {
      this.dialogAjoutAssu = true;
      this.dialogEdit = false;
      this.logoAssur = "/static/img-doc.png";
      this.formAssu = {};
      this.visiteCourant = []
    },
    newVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = false;
      this.logoVisit = "/static/img-doc.png";
      this.formVisite = {};
      this.visiteCourant = []
    },
    newVign() {
      this.dialogAjoutVign = true;
      this.dialogEdit = false;
      this.formVidn = {};
      this.vidangeCourant = [];
      // this.vidangeCourant.id = ""
      this.logoVignet = "/static/img-doc.png";
    },
    editVeh(ligne) {
      console.log("ligne", ligne);
      this.loadMarque(ligne.categorieId);
      this.loadModele(ligne.marqueId);
      this.loadSerie(ligne.modeleId);
      this.formVehicule = ligne;
      this.formVehicule.parcId = ligne.parcId;
      this.formVehicule.kilometrage = ligne.kilo;
      this.formVehicule.matricule = ligne.immat;
      this.formVehicule.numCarteGris = ligne.numCarte;
      this.formVehicule.numChassis = ligne.numChass;
      this.idVehModif = this.idVeh;
      this.imageCarteGris = ligne.urlCart;
      this.imageVeh = ligne.urlVeh;
      this.dialogAjoutVeh = true;
    },
    editAssu(ligne) {
      this.dialogAjoutAssu = true;
      this.dialogEdit = true;
      this.logoAssur = ligne.url;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.coutUtil = this.assuranceCourant.coutUtil;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      this.formAssu.statut = this.assuranceCourant.statut;
      this.selectCompagnLib = this.assuranceCourant.societeId;
      this.imageCarteGris = ligne.urlCarteGrise;
      this.imageVeh = ligne.photoVeh;
    },
    editVign(ligne) {
      console.log("ligne", ligne);
      this.dialogAjoutVign = true;
      this.dialogEdit = true;
      this.logoVignet = ligne.url;
      this.vidangeCourant = ligne;
      this.formVidn = Object.assign({}, ligne);
      this.formVidn.montant = this.vidangeCourant.montant;
      this.formVidn.statut = this.vidangeCourant.statut;
    },
    editVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = true;
      this.logoVisit = ligne.url;
      this.visiteCourant = ligne;
      this.formVisite = Object.assign({}, ligne);
      this.formVisite.montant = this.visiteCourant.montant;
      this.formVisite.statut = this.visiteCourant.statut;
    },
    deleteAssu() {
      let url = this.domaine + "parc/delete/assurance/" + this.idAssu;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Assurance supprimée avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000

          });
          this.dialogSuprAssu = false;
          this.selectTab('tab-3')
        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          this.dialogSuprAssu = false;
        }
      });
    },
    deleteVisit() {
      let url = this.domaine + "visite/delete/" + this.idVisit;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Visite technique supprimé avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          this.dialogSuprVisit = false;
          this.selectTab('tab-3')

        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          this.dialogSuprVisit = false;
        }
      });
    },
    deleteVign() {
      let url = this.domaine + "vidange/delete/" + this.idVign;
      this.$http.get(url).then(response => {
        if (response.body.rep == 1) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Vidange supprimée avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          this.dialogSuprVign = false;
          this.selectTab('tab-3')

        } else if (response.body.rep == 0) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          this.dialogSuprVign = false;
        }
      });
    },
     deleteConducteur() {
      this.loading = true
      let url = this.domaine + "conducteur/delete/vehicule/"+this.idConducteur+'/'+this.idVeh;
        this.$http.get(url).then(
          response => {
              if (response.body.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Véhicule retiré avec succès.",
                  type: "success",
                  position: "top-center",
            duration: 5000
                });
                this.loadVConducteur()
                this.dialogSuprCond = false
                this.loading = false
              }
          },
          error => {
            this.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
            this.loading = false;
          }
        );
    },
    submitAssu() {
      if (this.$refs.formAssu.validate()) {
        if (
          this.formAssu.attestation != "" &&
          this.formAssu.police != "" &&
          this.formAssu.montant > 0 &&
          this.formAssu.dateAssu != "" &&
          this.selectCompagnLib != "" &&
          this.formAssu.dateDebutAssu &&
          this.formAssu.dateFinAssu &&
          (this.formAssu.statut == 1 || this.formAssu.statut == 0)
        ) {
          var form = document.getElementById("formAssu");
          var data = new FormData(form);
          data.append("idVeh", this.idVeh);
          data.append("idCompagn", this.selectCompagnLib);
          data.append("statut", this.formAssu.statut);
          if (this.assuranceCourant.id) {
            data.append("id", this.assuranceCourant.id);
          } else {
            data.append("id", "");
          }
          this.loading = true;
          let url = this.domaine + "parc/new/assurance";
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1 || verif.code === 4) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Asssurance enregistrée avec succès.",
                    type: "success",
                    position: "top-center",
            duration: 5000
                  });

                  this.selectTab('tab-3')
                  this.loadInfoVeh(this.idVeh);
                  this.dialogAjoutAssu = false;
                  this.loading = false;
                  this.$refs.formAssu.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 2) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 3) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 1");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 2");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Assurance n'a pas été enregistré.",
          position: "top-center",
            duration: 5000
        });
        this.loading = false;
      }
    },
    submitVisit() {
      if (this.$refs.formVisite.validate()) {
        if (
          this.formVisite.numero != "" &&
          this.formVisite.dateDebut != "" &&
          this.formVisite.dateFin != "" &&
          this.formVisite.montant > 0 &&
          (this.formVisite.statut == 0 || this.formVisite.statut == 1)
        ) {
          var form = document.getElementById("formVisite");
          var data = new FormData(form);
          data.append("idVeh", this.idVeh);
          data.append("statut", this.formVisite.statut);
          let url = this.domaine + "visite/new";
          if (this.visiteCourant.id) {
            data.append("id", this.visiteCourant.id);
          } else {
            data.append("id", "");
          }
        this.loading = true;
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Visite technique enregistrée avec succès.",
                    type: "success",
                    position: "top-center",
            duration: 5000
                  });

                  this.selectTab('tab-3')
                  this.loadInfoVeh(this.idVeh);
                  this.dialogAjoutVisit = false;
                  this.loading = false;
                  this.$refs.formVisite.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 4) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 2) {
                  this.$message.error(verif.message);
                  this.loading = false;
                } else if (verif.code === 3) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vignette n'a pas été enregistrée.",
          position: "top-center",
            duration: 5000
        });
        this.loading = false;
      }
    },
    submitAttribution(){
      this.loading = true;
      var form = document.getElementById("formAttribueCondu");
      var data = new FormData(form);
      let url = this.domaine + "parc/attrib/vehicule/new";
      data.append("conducteur", this.formAttribueCondu.conducteur);
      data.append("vehicule", this.idVeh);
      this.$http.post(url, data).then(response => {
          this.loading = false;
          let verif = response.body;
          if (verif.code === 1) {
            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Conducteur affécté à ce vehicule.",
              type: "success",
              position: "top-center",
            duration: 5000
            });
            this.loadVConducteur()
            this.dialogAjoutVehiConducteur = false;
            this.loading = false;
          }
        },
        error => {
          this.$message.error("Ce véhicule déja été affecter à ce conducteur");
          this.loading = false;
        }
      );
    },
    loadVConducteur(){
    this.loading = true
    let url = this.domaine +"parc/conducteur-affecter/"+this.idVeh;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listConducteur = response.body.listConducteur;
          this.loading = false
        }
      },
       error => {
          this.$message.error("Impossible d'avoir la liste des conducteurs");
          this.loading = false;
        }
        );
    },
    deleteVehiCondu(row){
    this.loading = true
    let url = this.domaine + "conducteur/delete/vehicule/"+this.conducteurCourant.idCond+'/'+row.idVeh;
      this.$http.get(url).then(
        response => {
            if (response.body.code === 1) {
              this.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Véhicule retiré avec succès.",
                type: "success",
                position: "top-center"
              });
              this.loadVConducteur()
              this.loading = false
            }
        },
        error => {
          this.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
          this.loading = false;
        }
      );
    },
    submitVign() {
      this.loading = true;
      // if (this.$refs.formVidn.validate()) {
      if (
        (this.formVidn.numero != "" &&
          this.selectVehicule != "" &&
          this.formVidn.kiloActu != "" &&
          this.formVidn.kiloProch != "" &&
          this.formVidn.dateDebt != "" &&
          this.formVidn.montant > 0 &&
          this.formVidn.statut == 0) ||
        this.formVidn.statut == 1
      ) {
        var form = document.getElementById("formVidn");
        var data = new FormData(form);

        data.append("idVeh", this.idVeh);
        data.append("statut", this.formVidn.statut);
        let url = this.domaine + "vidange/new";
        if (this.vidangeCourant.id) {
          data.append("id", this.vidangeCourant.id);
        } else {
          data.append("id", "");
        }

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "vidange enregistrée avec succès.",
                  type: "success",
                  position: "top-center"
                });

                this.loadInfoVeh(this.idVeh);
                this.selectTab('tab-3')
                this.dialogAjoutVign = false;
                this.loading = false;
                this.$refs.formVidn.reset();
                this.selectVehicule = "";
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 3) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "vidange n'a pas été enregistrée.",
          position: "top-center",
            duration: 5000
        });
        this.loading = false;
      }
      // } else {
      //   this.$message.error('Veuillez renseigner les champs obligatoires')
      //   this.$notify.error({
      //     title: "ERREUR D'ENREGISTREMENT",
      //     message: "vidange n'a pas été enregistrée.",
      //     position: 'top-center'
      //   })
      //   this.loading = false
      // }
    },
    createVeh(idVehModif = "") {
      this.loading = true;
      if (
        this.formVehicule.marqueId == null ||
        this.formVehicule.modeleId == null ||
        this.formVehicule.serieId == null ||
        this.formVehicule.categorieId == null
      ) {
        this.loading = false;
        this.$message.error(
          "Veuillez renseigner correctement les champs categorie, marque, modele et serie"
        );
        return;
      }

      if (this.$refs.formVehicule.validate()) {
        var form = document.getElementById("formVehicule");
        var data = new FormData(form);
        let url = "";
        if (idVehModif !== "" && idVehModif !== undefined) {
          url = this.domaine + "parc/edit/vehicule/" + idVehModif;
        } else {
          url = this.domaine + "parc/new/vehicule"; //WebServiceBundle:ParcAutoController:newVehicule
        }
        data.append("idUser", this.user.id);
        data.append("type", this.formVehicule.categorieId);
        data.append("typeCarbu", this.formVehicule.typeCarbuId);
        data.append("marque", this.formVehicule.marqueId);
        data.append("modele", this.formVehicule.modeleId);
        data.append("serie", this.formVehicule.serieId);
        data.append("parc", this.formVehicule.parcId);
        data.append("dateAqui", this.formVehicule.dateAqui);
        data.append("annVeh", this.formVehicule.annVeh);

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              this.loading = false;
              this.e1 = 1;
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Véhicule enregistré avec succès.",
                  type: "success",
                  position: "top-right",
                  duration: 5000
                });
                this.dialogAjoutVeh = false;
                this.$refs.formVehicule.reset();
                this.loadInfoVeh(this.idVeh);
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              } else if (verif.code === 5) {
                this.loading = false;
                this.$message.error(verif.message);
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le véhicule n'a pas été enregistré.",
          position: "top-right"
        });
        this.loading = false;
        this.e1 = 1;
      }
    },
    imprimeFic(urlFic) {
      window.open(urlFic);
    },
    impmerFacture(ligne) {
      this.contratCourant = ligne;
      let url =
        this.domaine +
        "contrat/" +
        this.contratCourant.id +
        "/imprimer/facture";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    onFileCartePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageCarteGris = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileCarteGris = files[0];
    },
    onFileVehPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageVeh = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileVeh = files[0];
    },
    loadListConducteur() {
     this.loading = true;
     let url = this.domaine + "conducteur/index";
     this.$http.get(url).then(response => {
        if (response.body) {
          this.AllConducteur = response.body.conducteur;
        }
      });
    },
    loadNotif(idVeh) {
      let url = this.domaine + "tabParcauto/notif/" + idVeh;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.nbAssurAbs = response.body.nbAssurAbs;
            this.nbAssurAexp = response.body.nbAssurAexp;

            this.nbVisiteTechAbs = response.body.nbVisiteTechAbs;
            this.nbVisiteTechExp = response.body.nbVisiteTechExp;

            this.nbVignetteAbs = response.body.nbVignetteAbs;
            this.nbVignetteExp = response.body.nbVignetteExp;

            if (this.notif === "active" && this.nbAssurAbs != 0) {
              this.$vs.notify({
                title: "ASSURANCE NON-VALIDE",
                text: "Ce vehicule ne possede ou n'a pas une assurance valide",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 10000
              });
            }

            if (this.notif === "active" && this.nbAssurAexp != 0) {
              this.$vs.notify({
                title: "EXPIRATION ASSURANCE",
                text: " l'assurance(s) va expirer dans moins de 3 mois",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 10000
              });
            }

            if (this.notif === "active" && this.nbVisiteTechAbs != 0) {
              this.$vs.notify({
                title: "VISITE TECHNIQUE NON-VALIDE",
                text:
                  " Ce vehicule ne possede  ou n'a pas une visite technique valide",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 25000
              });
            }

            if (this.notif === "active" && this.nbVisiteTechExp != 0) {
              this.$vs.notify({
                title: "EXPIRATION VISITE TECHNIQUE",
                text: "La visite(s) technique va expirer dans moins de  3 mois",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 35000
              });
            }

            if (this.notif === "active" && this.nbVignetteAbs != 0) {
              this.$vs.notify({
                title: "VIGNETTE NON-VALIDE",
                text: "Ce vehicule ne possede ou n'a pas une vignette valide",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 45000
              });
            }

            if (this.notif === "active" && this.nbVignetteExp != 0) {
              this.$vs.notify({
                title: " EXPIRATION VIGNETTE",
                text: "La vignettes va expirer dans moins de 3 mois",
                color: "warning",
                position: "top-right",
                icon: "description",
                time: 60000
              });
            }
          }
        },
        response => {
          this.loading = false;
          this.$message.error("Erreur lors du chargement des notifications");
        }
      );
    }
  },
  mounted() {
    this.loadPage();
    this.loadListConducteur();
    this.loadInfoVeh(this.idVeh);
    this.loadCompagnie();
    this.loadCategorie();
    this.loadCarburant();
    this.loadParc();
    this.loadNotif(this.idVeh);
    this.loadBesoinVehValider();
  }
};
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}

.box-card {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FicheVehicule.vue